import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import PageHero from '@/components/feature/PageHero';
import Reveal from '@/components/base/Reveal';
import FloatingConsult from '@/components/feature/solution/FloatingConsult';
import { traceDetail } from '@/mocks/smart-agriculture';
import TraceVerify from './components/TraceVerify';
import TraceProfile from './components/TraceProfile';
import TraceSteps from './components/TraceSteps';

export default function SmartAgricultureTrace() {
  const d = traceDetail;

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="清远鸡溯源档案｜农产品数字身份证｜华辉数智"
        description="清远鸡全程溯源档案，一物一码。可查询生产主体、养殖基地、养殖批次、质量检测、包装赋码、冷链运输与市场销售全过程记录，数据实时同步、不可篡改。"
        keywords="农产品溯源,农产品数字身份证,清远鸡溯源,一物一码,智慧农业溯源"
        path="/solutions/smart-agriculture/trace"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '清远鸡 · 全程溯源档案',
          description:
            '清远鸡农产品数字身份证溯源档案，展示从养殖、检测、加工、仓储、冷链到销售的全过程可追溯记录。',
        }}
      />

      <PageHero
        eyebrow={d.eyebrow}
        title={d.title}
        titleHighlight={d.highlight}
        subtitle={d.subtitle}
        imageUrl={d.heroImage}
        imageAlt={d.heroAlt}
      />
      <Breadcrumb
        items={[
          { label: '产品与解决方案' },
          { label: '解决方案', href: '/solutions' },
          { label: '智慧农业', href: '/solutions/smart-agriculture' },
          { label: '溯源档案' },
        ]}
      />

      <main>
        <TraceVerify code={d.code} title={d.verifyTitle} desc={d.verifyDesc} metrics={d.metrics} />

        <TraceProfile
          basicTitle={d.basicTitle}
          basic={d.basic}
          inspectionTitle={d.inspectionTitle}
          inspectionNote={d.inspectionNote}
          inspections={d.inspections}
        />

        <TraceSteps title={d.stepsTitle} subtitle={d.stepsSubtitle} steps={d.steps} />

        {/* 底部说明 */}
        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-[1000px] mx-auto">
            <Reveal>
              <div className="rounded-2xl bg-foreground-950 p-6 md:p-10">
                <div className="flex items-center gap-3">
                  <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-500/20 text-accent-300">
                    <i className="ri-qr-scan-2-line text-2xl"></i>
                  </span>
                  <h2 className="font-heading font-bold text-background-50 text-lg md:text-xl">
                    让每件农产品都拥有一份数字档案
                  </h2>
                </div>
                <p className="mt-4 text-sm md:text-base text-foreground-300 leading-relaxed max-w-2xl">
                  溯源不是终点，而是起点。华辉数智智慧农业平台把生产、检测、仓储、冷链、销售连成一条数据链，让生产者好管理、让消费者放心买、让监管方查得到。
                </p>

                <div className="mt-6 flex flex-wrap gap-3">
                  <Link
                    to="/solutions/smart-agriculture"
                    className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-accent-400"
                  >
                    <i className="ri-arrow-left-line"></i>
                    返回智慧农业方案
                  </Link>
                  <Link
                    to="/contact/business"
                    className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-50/10 border border-background-50/20 text-background-100 text-sm whitespace-nowrap cursor-pointer transition-colors hover:bg-background-50/20"
                  >
                    <i className="ri-customer-service-2-line"></i>
                    咨询溯源方案
                  </Link>
                </div>

                <div className="mt-6 pt-5 border-t border-background-50/10 flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-shield-check-line text-accent-400"></i>
                  {d.footerNote}
                </div>
              </div>
            </Reveal>
          </div>
        </section>
      </main>

      <Footer />
      <FloatingConsult accentKey="green" />
    </div>
  );
}